import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

function SearchComponent({ onSearchSubmit }) {
    const [inputValue, setInputValue] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearchSubmit(inputValue);
    };

    return (
        <div className="search">
            <form className="search d-flex" onSubmit={handleSubmit}>
                <input className="form-control"
                    id="inputSearch"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Type film name"
                />
                <button type="submit" className="btn btn-secondary">
                    Search
                </button>
            </form>
        </div>
    );

}

export default SearchComponent;
